import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import emailjs from "@emailjs/browser";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Products from "./pages/Products";
import Process from "./pages/Process";
import Sustainability from "./pages/Sustainability";
import Contact from "./pages/Contact";

export default function App() {
  useEffect(() => {
    const key = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    if (key) {
      emailjs.init({ publicKey: key });
    }
  }, []);

  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/process" element={<Process />} />
          <Route path="/sustainability" element={<Sustainability />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}
